Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Docs = void 0;

var core_1 = require("@emotion/core");

var react_1 = require("react");

var core_2 = require("@wheelroom/core");

var wheel_text_1 = require("@wheelroom/wheel-text");

exports.Docs = function (props) {
  if (!props.docs) {
    return null;
  }

  return core_1.jsx(core_2.Box, {
    is: "article",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style
    })
  }, !props.data.hideHeader && core_1.jsx(core_2.Flex, {
    is: "header",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.header
    })
  }, !props.data.hideBreadcrumb && core_1.jsx(core_2.Box, {
    is: "nav",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumb
    })
  }, core_1.jsx(core_2.Action, {
    hideIcon: true,
    url: "/",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbAction
    })
  }, "Home"), core_1.jsx(core_2.Box, {
    is: "span",
    role: "presentation",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbSpacer
    })
  }, "\u203A"), core_1.jsx(core_2.Action, {
    hideIcon: true,
    url: "/docs",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbAction
    })
  }, "Docs"), props.docs.parentDocs && core_1.jsx(react_1.Fragment, null, core_1.jsx(core_2.Box, {
    is: "span",
    role: "presentation",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbSpacer
    })
  }, "\u203A"), core_1.jsx(core_2.Action, {
    hideIcon: true,
    url: "/docs/" + props.docs.parentDocs.slug,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbAction
    })
  }, props.docs.parentDocs.heading)), core_1.jsx(core_2.Box, {
    is: "span",
    role: "presentation",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbSpacer
    })
  }, "\u203A"), core_1.jsx(core_2.Box, {
    is: "span",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.breadcrumbCurrent
    })
  }, props.docs.heading)), !props.data.hideHeading && core_1.jsx(core_2.Heading, {
    is: "h1",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.heading
    })
  }, props.docs.heading)), !props.data.hideRichText && core_1.jsx(wheel_text_1.RichText, {
    locale: props.locale,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.richText
    }),
    textJson: props.docs.text.json
  }));
};